import { render, staticRenderFns } from "./ArtistChannelManage.vue?vue&type=template&id=66cecb1b&scoped=true&"
import script from "./ArtistChannelManage.vue?vue&type=script&lang=js&"
export * from "./ArtistChannelManage.vue?vue&type=script&lang=js&"
import style0 from "./ArtistChannelManage.vue?vue&type=style&index=0&id=66cecb1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cecb1b",
  null
  
)

export default component.exports